"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_query_1 = require("react-query");
var api_service_1 = require("../../../api/api_service");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var table_data_1 = require("../../../constants/table_data");
var array_helpers_1 = require("../../../utils/array_helpers");
var fe_services_1 = require("../fe_services");
var menu_constants_1 = require("../../../menuList/menu_constants");
var modal_component_1 = require("../../../common/modal/modal_component");
var text_field_with_datepicker_1 = require("../../../common/text_filed/text_field_with_datepicker");
var button_component_1 = require("../../../common/buttons/button_component");
var moment = require("moment");
('../../../constants/appConstants');
var FEExitedList = function (_a) {
    var searchValue = _a.searchValue, selectedCities = _a.selectedCities, selectedCityIds = _a.selectedCityIds, selectedStateIds = _a.selectedStateIds, CurrentPagelimit = _a.CurrentPagelimit, billingModule = _a.billingModule, isFilterButton = _a.isFilterButton;
    var feManagementFeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.feManagement);
    var _b = React.useState(undefined), feExitedLis = _b[0], setExitedList = _b[1];
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = React.useState(1), pageCount = _d[0], setpageCount = _d[1];
    var _e = React.useState(0), totalPageCount = _e[0], setTotalPageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = React.useState(0), lastWorkingDate = _g[0], setLastWorkingDate = _g[1];
    var _h = React.useState(), userId = _h[0], setUserId = _h[1];
    var _j = React.useState(false), open = _j[0], setOpen = _j[1];
    var fetchExitFE = function (endPoint, payLoad, domain) {
        (0, fe_services_1.fetchFEList)(endPoint, payLoad, domain)
            .then(function (response) {
            setErrorMessage("");
            var pageSize = CurrentPagelimit
                ? parseInt(CurrentPagelimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            setExitedList(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err);
            setExitedList([]);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['exit-fe', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = (0, array_helpers_1.createPayloadForFEList)(appConstants_1.FE_USER_TYPES.exited, searchValue, selectedCities, selectedCityIds, selectedStateIds, billingModule);
        payload.page = currentPage;
        payload.size = CurrentPagelimit
            ? parseInt(CurrentPagelimit.value.toString())
            : 50;
        fetchExitFE(api_service_1.api_service.api_urls.FE_LIST, payload, process.env.VENDOR_BASE_URL);
    }).refetch;
    var fetchTableColumns = function () {
        var tableColumns = table_data_1.default.FE_EXIT_COLUMNS;
        if (feManagementFeatures[menu_constants_1.FEATURE_CONSTANTS.fe_billing_details]) {
            tableColumns = __spreadArray(__spreadArray([], table_data_1.default.FE_EXIT_COLUMNS, true), table_data_1.default.BILLING_COLUMNS, true);
        }
        return tableColumns;
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () {
        setOpen(false);
        setLastWorkingDate(null);
    };
    var handleSubmit = function () {
        var payload = {
            exit_date: moment(lastWorkingDate).format('YYYY-MM-DD'),
            user_id: userId
        };
        (0, fe_services_1.submitExitFeDate)(payload)
            .then(function (res) {
            if (res.statusCode == 200) {
                setOpen(false);
                setLastWorkingDate(null);
                refetch();
            }
        });
    };
    var onRowClickedHandler = function (e) {
        var _a;
        var parsedDate = moment((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.date_of_exit, 'DD/MM/YYYY, hh:mm a').toDate();
        setLastWorkingDate(parsedDate);
        setUserId(e === null || e === void 0 ? void 0 : e.data.id);
        handleOpen();
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    return (React.createElement("div", { className: "unclickablerow custom-pagination-table " },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: fetchTableColumns(), rows: feExitedLis && feExitedLis, errorMessage: errorMessage, pagination: false, onRowClicked: onRowClickedHandler }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: feExitedLis === null || feExitedLis === void 0 ? void 0 : feExitedLis.length, currentPageLimits: CurrentPagelimit === null || CurrentPagelimit === void 0 ? void 0 : CurrentPagelimit.value }),
        React.createElement(modal_component_1.default, { open: open },
            React.createElement("div", { className: "modal-header header-wrapper" },
                React.createElement("h2", { className: "heading" }, "Last Date Of Working")),
            React.createElement(text_field_with_datepicker_1.default, { required: true, label: 'Last Working Date', onChange: function (e) {
                    setLastWorkingDate(e);
                }, name: "fromDate", value: lastWorkingDate }),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: handleClose }),
                React.createElement(button_component_1.default, { buttonName: "Submit", color: "yellow", onClickHandler: handleSubmit })))));
};
exports.default = FEExitedList;
